(()=>{
if(!document.querySelector('.ss-shared-chrome'))return;
const menuButtons=[...document.querySelectorAll('[data-menu]')];
const mobileToggle=document.querySelector('.mobile-menu-toggle');
const nav=document.querySelector('.meganav');
function closeMenus(){menuButtons.forEach(b=>{b.dataset.hoverOpened='false';b.setAttribute('aria-expanded','false');document.getElementById(b.getAttribute('aria-controls')).hidden=true;});}
function openMenu(button){closeRewards();closeMenus();button.setAttribute('aria-expanded','true');document.getElementById(button.getAttribute('aria-controls')).hidden=false;}
menuButtons.forEach(button=>{
 button.addEventListener('click',()=>{if(button.dataset.hoverOpened==='true'){button.dataset.hoverOpened='false';return;}const open=button.getAttribute('aria-expanded')==='true';closeMenus();if(!open)openMenu(button);});
 button.closest('.nav-item').addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&innerWidth>700){openMenu(button);button.dataset.hoverOpened='true';}});
});
document.querySelector('.v2-header').addEventListener('pointerleave',()=>{if(innerWidth>700)closeMenus();});
document.addEventListener('click',e=>{if(!e.target.closest('.v2-header')){closeMenus();nav.classList.remove('mobile-open');mobileToggle.setAttribute('aria-expanded','false');}});
document.querySelector('.v2-header').addEventListener('focusout',e=>{if(!e.currentTarget.contains(e.relatedTarget))closeMenus();});
mobileToggle.addEventListener('click',()=>{const open=nav.classList.toggle('mobile-open');if(open){closeRewards();if(quickResources)quickResources.open=false;}mobileToggle.setAttribute('aria-expanded',String(open));mobileToggle.setAttribute('aria-label',open?'Close navigation':'Open navigation');if(!open)closeMenus();});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!document.querySelector('dialog[open]')){const active=menuButtons.find(b=>b.getAttribute('aria-expanded')==='true');closeMenus();if(active)active.focus();else if(nav.classList.contains('mobile-open')){nav.classList.remove('mobile-open');mobileToggle.setAttribute('aria-expanded','false');mobileToggle.focus();}}});
const reduceMotion=matchMedia('(prefers-reduced-motion: reduce)');
const rewardsRoot=document.querySelector('.compact-rewards');
const rewardsTrigger=rewardsRoot?.querySelector('.rewards-trigger');
const rewardsPanel=rewardsRoot?.querySelector('.rewards-panel');
let rewardsHoverOpened=false;
function closeRewards(){if(!rewardsRoot)return;rewardsTrigger.setAttribute('aria-expanded','false');rewardsPanel.hidden=true;rewardsHoverOpened=false;}
function openRewards(){closeMenus();rewardsTrigger.setAttribute('aria-expanded','true');rewardsPanel.hidden=false;}
rewardsTrigger?.addEventListener('click',()=>{if(rewardsHoverOpened){rewardsHoverOpened=false;return;}if(rewardsTrigger.getAttribute('aria-expanded')==='true')closeRewards();else openRewards();});
rewardsRoot?.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&matchMedia('(min-width:701px) and (hover:hover)').matches){openRewards();rewardsHoverOpened=true;}});
rewardsRoot?.addEventListener('pointerleave',()=>{if(innerWidth>700&&!rewardsRoot.contains(document.activeElement))closeRewards();});
rewardsRoot?.addEventListener('focusout',e=>{if(!rewardsRoot.contains(e.relatedTarget))closeRewards();});
document.addEventListener('click',e=>{if(!e.target.closest('.compact-rewards'))closeRewards();});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&rewardsTrigger?.getAttribute('aria-expanded')==='true'){closeRewards();rewardsTrigger.focus();}});

const quickResources=document.querySelector('.quick-resources');
quickResources?.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){quickResources.open=true;quickResources.dataset.hoverOpened='true';}});
quickResources?.addEventListener('pointerleave',()=>{if(!quickResources.contains(document.activeElement))quickResources.open=false;});
quickResources?.addEventListener('focusout',e=>{if(!quickResources.contains(e.relatedTarget))quickResources.open=false;});
document.addEventListener('click',e=>{if(quickResources&&!quickResources.contains(e.target))quickResources.open=false;});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&quickResources?.open){quickResources.open=false;quickResources.querySelector('summary').focus();}});
const featureRotator=document.querySelector('.feature-rotator');
if(featureRotator){
 const callouts=[...featureRotator.querySelectorAll('.feature-callout')];let index=0;
 setInterval(()=>{if(document.hidden||reduceMotion.matches)return;callouts[index].hidden=true;index=(index+1)%callouts.length;callouts[index].hidden=false;},4000);
}

quickResources?.querySelector('summary').addEventListener('click',e=>{if(quickResources.dataset.hoverOpened==='true'){e.preventDefault();quickResources.dataset.hoverOpened='false';}});

const phoneLayout=matchMedia('(max-width:700px)');
const footerGroups=[...document.querySelectorAll('.footer-col')];
const menuGroups=[...document.querySelectorAll('.mega-group')];
function configurePhoneLayout(){
 footerGroups.forEach(group=>{group.open=!phoneLayout.matches;group.querySelector('summary').tabIndex=phoneLayout.matches?0:-1;});
 menuGroups.forEach(group=>{
  const first=group===group.parentElement.querySelector('.mega-group');
  const expanded=!phoneLayout.matches||first;
  group.querySelector('.mega-group-toggle').setAttribute('aria-expanded',String(expanded));
  group.querySelector('.mega-group-links').classList.toggle('mobile-collapsed',!expanded);
 });
 if(!phoneLayout.matches){document.body.classList.remove('mobile-navigation-open');nav.classList.remove('mobile-open');mobileToggle.setAttribute('aria-expanded','false');closeMenus();}

}
menuGroups.forEach(group=>group.querySelector('.mega-group-toggle').addEventListener('click',()=>{
 const button=group.querySelector('.mega-group-toggle');
 const expanded=button.getAttribute('aria-expanded')!=='true';
 button.setAttribute('aria-expanded',String(expanded));
 group.querySelector('.mega-group-links').classList.toggle('mobile-collapsed',!expanded);
}));
function syncPhoneNavigation(){
 const open=phoneLayout.matches&&nav.classList.contains('mobile-open');
 document.body.classList.toggle('mobile-navigation-open',open);
 mobileToggle.setAttribute('aria-label',open?'Close navigation':'Open navigation');
 document.querySelectorAll('main,footer,.review-bar,.compact-rewards,.feature-bar,.mobile-category-navigation').forEach(region=>region.inert=open);
 if(open)document.documentElement.style.setProperty('--mobile-nav-top',`${Math.ceil(document.querySelector('.v2-header').getBoundingClientRect().bottom)}px`);
}
new MutationObserver(syncPhoneNavigation).observe(nav,{attributes:true,attributeFilter:['class']});
window.addEventListener('resize',syncPhoneNavigation);
phoneLayout.addEventListener('change',configurePhoneLayout);
configurePhoneLayout();
footerGroups.forEach(group=>group.querySelector('summary').addEventListener('click',e=>{if(!phoneLayout.matches)e.preventDefault();}));
document.addEventListener('keydown',e=>{
 if(e.key!=='Tab'||!document.body.classList.contains('mobile-navigation-open'))return;
 const focusable=[...document.querySelector('.v2-header').querySelectorAll('a[href],button,summary')].filter(el=>el.getBoundingClientRect().width>0&&!el.disabled&&el.tabIndex>=0);
 const first=focusable[0],last=focusable.at(-1);
 if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
 else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
});



function initializeHomepageOffer(){
 const button=document.querySelector('[data-open-offer]'),dialog=document.getElementById('SSOfferDialog');
 if(!button||!dialog||button.dataset.offerInitialized)return;
 button.dataset.offerInitialized='true';
 const open=()=>{
  if(!dialog.open)dialog.showModal();
  // Keep focus in the tap event so mobile Safari can open the keyboard.
  (dialog.querySelector('input[type="email"]')||dialog.querySelector('[data-offer-use]')||dialog.querySelector('[data-close-offer]'))?.focus({preventScroll:true});
 };
 button.addEventListener('click',open);
 dialog.querySelector('[data-close-offer]').addEventListener('click',()=>dialog.close());
 dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
 dialog.addEventListener('close',()=>button.focus({preventScroll:true}));
 const form=dialog.querySelector('form');
 form?.addEventListener('submit',()=>{
  // Shopify can show a verification challenge outside the dialog.
  // Release the top layer so the challenge remains visible and usable.
  dialog.close();
 });
 if(dialog.querySelector('[data-offer-success],[data-offer-errors]'))open();
}
initializeHomepageOffer();

// Explicit offer link from another storefront page.
if(new URLSearchParams(location.search).get('offer')==='5'){document.querySelector('[data-open-offer]')?.click();}

/* Shared cart quantity: update after successful cart changes. */
(()=>{
 const link=document.querySelector('[data-ss-cart-link]');
 const badge=link?.querySelector('[data-ss-cart-count]');
 if(!badge||window.__ssCartCountInitialized)return;
 window.__ssCartCountInitialized=true;
 const originalFetch=window.fetch;
 let timer,requestNumber=0;
 const paint=count=>{
  count=Math.max(0,Number(count)||0);badge.textContent=String(count);badge.hidden=count===0;
  link.setAttribute('aria-label',count?`Shopping bag, ${count} ${count===1?'item':'items'}`:'Shopping bag');
 };
 const refresh=async()=>{
  const current=++requestNumber;
  try{
   const response=await originalFetch.call(window,link.dataset.cartStatusUrl,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
   if(!response.ok)return;
   const cart=await response.json();if(current===requestNumber)paint(cart.item_count);
  }catch(error){/* Preserve the server-rendered count when the network is unavailable. */}
 };
 const schedule=()=>{clearTimeout(timer);timer=setTimeout(refresh,150);};
 const mutation=url=>{
  try{return /\/cart\/(add|change|update|clear)(?:\.js|\.json)?$/.test(new URL(url,location.href).pathname);}catch(error){return false;}
 };
 window.fetch=function(input,options){
  const promise=originalFetch.apply(this,arguments);
  if(mutation(typeof input==='string'||input instanceof URL?input:input?.url)){
   return promise.then(response=>{if(response.ok)schedule();return response;});
  }
  return promise;
 };
 const originalOpen=XMLHttpRequest.prototype.open,originalSend=XMLHttpRequest.prototype.send,tracked=new WeakSet();
 XMLHttpRequest.prototype.open=function(method,url){
  if(mutation(url))tracked.add(this);else tracked.delete(this);
  return originalOpen.apply(this,arguments);
 };
 XMLHttpRequest.prototype.send=function(){
  if(tracked.has(this))this.addEventListener('loadend',()=>{if(this.status>=200&&this.status<300)schedule();},{once:true});
  return originalSend.apply(this,arguments);
 };
 ['ajaxProduct:added','ajaxCart:updated','cart:updated','cart:change','cart:refresh'].forEach(event=>document.addEventListener(event,schedule));
 window.addEventListener('pageshow',schedule);window.addEventListener('focus',schedule);
 document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
 refresh();
})();
/* End shared cart quantity */

/* Storefront search: open the existing predictive-search component in place. */
(()=>{
 const trigger=document.querySelector('[data-ss-search-open]');
 const panel=document.querySelector('#SSHeaderSearch');
 if(!trigger||!panel||trigger.dataset.ssSearchInitialized)return;
 trigger.dataset.ssSearchInitialized='true';
 const header=trigger.closest('.v2-header');
 const input=panel.querySelector('input[type="search"]');
 const close=(notify=true)=>{
  if(panel.hidden)return;
  panel.hidden=true;header.classList.remove('ss-search-open');
  trigger.setAttribute('aria-expanded','false');
  if(notify)document.dispatchEvent(new CustomEvent('predictive-search:close'));
  document.body.classList.remove('predictive-overflow-hidden');
  trigger.focus({preventScroll:true});
 };
 trigger.addEventListener('click',event=>{
  event.preventDefault();
  event.stopImmediatePropagation();
  if(!panel.hidden){close();return;}
  document.querySelector('.mobile-menu-toggle[aria-expanded="true"]')?.click();
  document.querySelector('.rewards-trigger[aria-expanded="true"]')?.click();
  panel.hidden=false;header.classList.add('ss-search-open');
  trigger.setAttribute('aria-expanded','true');
  document.dispatchEvent(new CustomEvent('predictive-search:open',{detail:{context:'header'}}));
  // iOS opens its keyboard only while focus stays in the tap's activation event.
  input.focus({preventScroll:true});
 });
 panel.querySelector('.btn--close-search').addEventListener('click',event=>{event.preventDefault();close();});
 panel.querySelector('[data-screen]').addEventListener('click',()=>close());
 panel.addEventListener('click',event=>event.stopPropagation());
 document.addEventListener('predictive-search:close-all',()=>close(false));
 panel.addEventListener('keydown',event=>{
  if(event.key==='Escape'){event.preventDefault();close();return;}
  if(event.key!=='Tab')return;
  const controls=[...panel.querySelectorAll('input:not([type="hidden"]),button,a[href]')].filter(el=>el.getClientRects().length);
  const first=controls[0],last=controls[controls.length-1];
  if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
  else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
 });
})();
/* End storefront search */

function initializeSharedCart(){
 const cart=document.querySelector('.ss-shared-cart');
 if(!cart||cart.dataset.initialized||!window.theme?.HeaderCart)return;
 cart.dataset.initialized='true';window.theme.settings.overlayHeader=false;
 new window.theme.HeaderCart();
 const align=()=>document.documentElement.style.setProperty('--ss-header-bottom',document.querySelector('.v2-header').getBoundingClientRect().bottom+'px');
 window.addEventListener('scroll',align,{passive:true});window.addEventListener('resize',align);align();
}
document.addEventListener('page:loaded',initializeSharedCart);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeSharedCart,{once:true});else initializeSharedCart();

})();
